var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 16.625H5.54166C2.37499 16.625 1.58333 15.8333 1.58333 12.6667V6.33333C1.58333 3.16667 2.37499 2.375 5.54166 2.375H13.4583C16.625 2.375 17.4167 3.16667 17.4167 6.33333V12.6667C17.4167 15.8333 16.625 16.625 13.4583 16.625Z",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 6.33333H15.0417",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 9.5H15.0417",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 12.6667H15.0417",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72917 8.93792C7.52054 8.93792 8.16208 8.29638 8.16208 7.505C8.16208 6.71362 7.52054 6.07208 6.72917 6.07208C5.93779 6.07208 5.29625 6.71362 5.29625 7.505C5.29625 8.29638 5.93779 8.93792 6.72917 8.93792Z",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.9279C9.38916 11.78 8.47875 10.8775 7.33083 10.7746C6.935 10.735 6.53124 10.735 6.12749 10.7746C4.97958 10.8854 4.06916 11.78 3.95833 12.9279",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalCard);
export default __webpack_public_path__ + "static/media/personal-card.24caa12268814a58367932e42d25ad72.svg";
export { ForwardRef as ReactComponent };